<template>

    <v-page>

        <transition name="modal">
            <v-modal-template-test v-if="showModal === 'test'" :template="template" />
        </transition>

        <v-page-header icon="fas fa-envelope-open-text">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'templates' }">Templates</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="template" :title="template.name" @saved="updateTemplateName" editable />
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="template" :uuid="template.id" />
            <v-button-toolbar>
                <v-button size="sm" btn-style="secondary" @click.native="$store.commit('showModal', 'test')">Test Template</v-button>
                <v-button size="sm" @click.native="updateTemplate" :loading="loading">Save Template</v-button>
            </v-button-toolbar>
        </v-page-filters>

        <v-page-body :class="template ? 'p-0' : ''">
            <v-builder mode="template" :action="template" />
        </v-page-body>

    </v-page>

</template>

<script>

import axios from 'axios';
import BuilderUtil from '@builder/utils/BuilderUtil';
import ModalTemplateTest from '@modals/template/ModalTemplateTest';
import ProjectApi from '@api/ProjectApi';
import TemplateApi from '@api/TemplateApi';

export default {

    components: {
        'v-modal-template-test': ModalTemplateTest,
    },

    data() {
        return {
            loading: false,
            template: null,
        }
    },

    mounted() {
        this.reload();
    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                ProjectApi.getProject(this.project.id),
                TemplateApi.getTemplate(this.$route.params.id),
            ];
            axios.all(requests)
                .then(axios.spread((resProject, resTemplate) => {
                    this.$store.commit('loading', false);
                    this.template = resTemplate.data.data;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        async updateTemplate() {
            this.loading = true;
            this.$store.commit('builder/setSelectedPanel', null);
            BuilderUtil.saveBlocks();
            let params = this.$store.getters['builder/action'];
            TemplateApi.updateTemplate(this.template.id, params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        updateTemplateName(name) {
            this.$store.commit('loading', true);
            TemplateApi.updateTemplateName(this.template.id, name)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    }

}

</script>